<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :model="form"
               label-width="100px"
               style="width: 100%">
        <el-row>
          <el-row>
            <!-- <el-col :span="6">
              <el-form-item label-width prop="create_date" label="日期">
                <el-input v-model="form.create_date"></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="6">
              <el-form-item prop="platform_from"
                            label="平台">
                <el-select clearable
                           v-model="form.platform_from"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiatradefrom"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label-width
                            prop="profession"
                            label="行业">
                <el-select clearable
                           v-model="form.profession"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiaProfession"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession1"
                            label="一级行业">
                <el-select clearable
                           v-model="form.profession1"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiaProfession1"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession2"
                            label="二级行业">
                <el-select clearable
                           v-model="form.profession2"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiaProfession2"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession3"
                            label="三级行业">
                <el-select clearable
                           v-model="form.profession3"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiaProfession3"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession4"
                            label="四级行业">
                <el-select clearable
                           v-model="form.profession4"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiaProfession4"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession5"
                            label="五级行业">
                <el-select clearable
                           v-model="form.profession5"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiaProfession5"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="profession6"
                            label="六级行业">
                <el-select clearable
                           v-model="form.profession6"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in maijiaProfession6"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="cate"
                            label="分类">
                <el-input v-model="form.cate"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="brand"
                            label="品牌">
                <el-input v-model="form.brand"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="sales_volume"
                            label="销量">
                <!-- <el-input v-model="form.sales_volume"></el-input> -->
                <number-range v-model="form.sales_volume" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="sales"
                            label="销售额">
                <!-- <el-input v-model="form.sales"></el-input> -->
                <number-range v-model="form.sales" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="create_date"
                            label="日期">
                <el-date-picker v-model="form.create_date"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label-width prop="from" label="平台">
                <el-input v-model="form.from"></el-input>
              </el-form-item>
            </el-col>-->

          </el-row>

          <el-row v-show="searchAreaStatus">
            <el-col :span="6">
              <el-form-item label-width
                            prop="count_shop"
                            label="店铺数">
                <!-- <el-input v-model="form.count_shop"></el-input> -->
                <number-range v-model="form.count_shop" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="count_shop"
                            label="宝贝数">
                <!-- <el-input v-model="form.count_shop"></el-input> -->
                <number-range v-model="form.count_shop" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="count_comment"
                            label="评论数">
                <!-- <el-input v-model="form.count_comment"></el-input> -->
                <number-range v-model="form.count_comment" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="count_collect"
                            label="收藏数">
                <!-- <el-input v-model="form.count_collect"></el-input> -->
                <number-range v-model="form.count_collect" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
        <el-button type="primary" size="medium" @click="dataMoint">数据监控</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData">
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="日期"></el-table-column>
      <el-table-column prop="cate"
                       align="center"
                       header-align="center"
                       label="分类"></el-table-column>
      <el-table-column prop="profession1"
                       align="center"
                       header-align="center"
                       label="一级行业"></el-table-column>
      <el-table-column prop="profession2"
                       align="center"
                       header-align="center"
                       label="二级行业"></el-table-column>
      <el-table-column prop="profession3"
                       align="center"
                       header-align="center"
                       label="三级行业"></el-table-column>
      <el-table-column prop="profession4"
                       align="center"
                       header-align="center"
                       label="四级行业"></el-table-column>
      <el-table-column prop="profession5"
                       align="center"
                       header-align="center"
                       label="五级行业"></el-table-column>
      <el-table-column prop="profession6"
                       align="center"
                       header-align="center"
                       label="六级行业"></el-table-column>
      <el-table-column prop="platform_from"
                       align="center"
                       header-align="center"
                       label="平台"></el-table-column>
      <el-table-column prop="brand"
                       align="center"
                       header-align="center"
                       label="品牌"></el-table-column>
      <el-table-column prop="sales_volume"
                       align="center"
                       header-align="center"
                       label="销量"></el-table-column>
      <el-table-column prop="sales"
                       align="center"
                       header-align="center"
                       label="销售额"></el-table-column>
      <el-table-column prop="count_shop"
                       align="center"
                       header-align="center"
                       label="店铺数"></el-table-column>
      <el-table-column prop="count_shop"
                       align="center"
                       header-align="center"
                       label="宝贝数"></el-table-column>
      <el-table-column prop="count_comment"
                       align="center"
                       header-align="center"
                       label="评论数"></el-table-column>
      <el-table-column prop="count_collect"
                       align="center"
                       header-align="center"
                       label="收藏数"></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-component ref="refExportDialog"
                      @submit="exportSubmit" />
    <import-simple @submit="handleFile"
                   ref="refImportDialog" />
    <maijia-datamoint ref="refMaijiaDatamoint"
                   ></maijia-datamoint>
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { getmaijiaProfession } from '@/common/mixins/select'
import importSimple from '@/base/importDialogSimple'
import ExportComponent from './export-dialog'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import maijiaDatamoint from '../maijiaDatamoint'
export default {
  mixins: [ActionLine, SearchMixin, getmaijiaProfession],
  components: { importSimple, ExportComponent, maijiaDatamoint },
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      maijiatradefrom: [],
      Desc,
      maijiaProfession1: [],
      maijiaProfession2: [],
      maijiaProfession3: [],
      maijiaProfession4: [],
      maijiaProfession5: [],
      maijiaProfession6: [],
    }
  },
  created() {
    // this.getTableData();
    this.getpf()
    this.getmaijiaplate()
  },
  methods: {
    async getmaijiaplate() {
      let name = this.$route.name
      console.log('route', this.$route)
      console.log(name)
      let { data, err } = await this.axiosApi({
        url: `getmaijiaplate/${name}`,
      })

      if (data && data.data.meta.status === 200) {
        this.maijiatradefrom = data.data.data
      } else {
        this.maijiatradefrom = []
      }
    },
    async handleImport() {
      // 获取 上次导入的时间
      // debugger;
      let time = await this.getTime()
      this.$refs.refImportDialog.show([], time)
    },
    async getTime() {
      // /maijiaDownloadtime/{reportname}
      let name = this.$route.meta.routeName.split('.')[1]
      let time
      this.loading = true
      let { data, err } = await this.axiosApi({
        url: `${this.Desc.getTime_api.url}/${name}`,
      })
      this.loading = false

      if (data && data.data.meta.status === 200) {
        console.log('data', data)
        time = data.data.data[0]
        return time
      } else {
        dealReturn(data, err)
      }
    },
    //获取行业下拉数据
    async getpf_api(n) {
      // /maijiaDownloadtime/{reportname}
      let name = this.$route.meta.routeName.split('.')[1]
      // let listName = 'this.maijiaProfession' + n
      // console.log(listName)
      // let time
      // this.loading = true
      let { data, err } = await this.axiosApi({
        url: `${this.Desc.getpf_api.url}/${name}/${n}`,
      })
      // this.loading = false

      if (data && data.data.meta.status === 200) {
        // console.log('data', data.data.data)
        this['maijiaProfession' + n] = data.data.data

        // time = data.data.data[0]
        // return time
      } else {
        dealReturn(data, err)
      }
    },
    getpf() {
      for (let index = 1; index < 7; index++) {
        this.getpf_api(index)
      }
    },
    dataMoint() {
      this.$refs.refMaijiaDatamoint.show()
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/maijia/maijia-professionbrandtop/index.vue